<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
//  打印工具
//  const Vconsole =require("./vconsole.min.js");
export default {
  name: "App",
  mounted() {
    // 页面进来开始打印
    // let vconsole = new Vconsole();
    // console.log("vconsole",vconsole)
  }
};
//得到手机屏幕的宽度
// let htmlWidth =
//   document.documentElement.clientWidth || document.body.clientWidth;
// console.log("htmlWidth", htmlWidth);
// 禁止ios自动放大
window.onload = function() {
  document.addEventListener("touchstart", function(event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  var lastTouchEnd = 0;
  document.addEventListener(
    "touchend",
    function(event) {
      var now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );
};

</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
body {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue